import Vue from 'vue';
import Vuex from 'vuex';



Vue.use(Vuex);

const state = {
    drawer: null,
    showOrderDrawer: null,
    breadcrumbsItems: [],
    sidebarLinks: [
        {
            icon: 'mdi-home',
            text: 'الرئيسية',
            name: 'home',
            url: '/app/home'
        },
        {
            icon: 'mdi-waveform',
            text: 'تسجيلات الراديو',
            name: 'recordings',
            url: '/app/recordings',
            subtitle: ' '

        },
        {
            icon: 'mdi-book-open-page-variant-outline',
            text: 'قراءات',
            name: 'other-narrations',
            url: '/app/other-narrations',
            subtitle: ' '

        },
        {
            icon: 'mdi-human-child',
            text: 'اطفال',
            name: 'kids',
            url: '/app/kids',
            subtitle: ' '

        },
        // {
        //     icon: 'mdi-human-man',
        //     text: 'قالون',
        //     name: 'qalon',
        //     url: '/app/qalon',
        //     subtitle: ' '

        // }
    ],
};

const mutations = {
    SET_DRAWER(state, drawer) {
        state.drawer = drawer;
    },
    SET_BREADCRUMBS(state, breadcrumbsItems) {
        state.breadcrumbsItems = breadcrumbsItems;
    },
    SET_SHOW_ORDER_DRAWER(state, showOrderDrawer) {
        state.showOrderDrawer = showOrderDrawer;
    }
};

const actions = {};

const getters = {};
const modulesFiles = require.context('./modules', true, /\.js$/);

const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
    const value = modulesFiles(modulePath);
    modules[moduleName] = value.default;
    return modules;
}, {});

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules
});

